/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
import { AjaxError } from "rxjs/ajax";
import { ActionType, createAction, createAsyncAction } from "typesafe-actions";
import { Wmp } from "../../db/stores/wmps";

export const getWmps = createAsyncAction(
  "GET_WMPS_REQUEST",
  "GET_WMPS_SUCCESS",
  "GET_WMPS_FAILURE"
)<undefined, Wmp[], AjaxError>();

export const throttledGetWmps = createAction('THROTTLED_GET_WMPS');

export const wmpsDatabaseUpdated = createAction(
  "WMPS_DATABASE_UPDATED",
  action => () => action()
);

export const wmpsDatabaseUpdateError = createAction(
  "WMPS_DATABASE_UPDATE_ERROR",
  action => (error: Error) => action(error)
);

export type WmpActions = ActionType<typeof getWmps>
| ActionType<typeof wmpsDatabaseUpdated>
| ActionType<typeof wmpsDatabaseUpdateError>
| ActionType<typeof throttledGetWmps>
